import {API_BASE_URL, UIDEVENTPART, UIDEVENT} from '../constants';

export const getUserInfoURL= () => {
  return `${API_BASE_URL}/me.json`;
};

export const getUserAccommodationInfoURL = (uidClubMember, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/tenants/${uidClubMember}.json`;
};

export const getGeographyURL = (uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/maps.json`;
};

export const getCurrentStateURL = (uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/spots.json`;
};

export const getStateForSpotURL = (spotIdentifier, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/spots/${spotIdentifier}.json`;
};


// Called with PUT request
export const holdSpotURL = (spotIdentifier, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/spots/${spotIdentifier}.json`;
};


// Called with DELETE request
export const cancelHoldSpotURL = (spotIdentifier, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/spots/${spotIdentifier}.json`;
};


// Called with PUT request
export const reserveSpotURL = (spotIdentifier, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/spots/${spotIdentifier}.json`;
};


// Called with DELETE request
export const unreserveSpotURL = (spotIdentifier, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/spots/${spotIdentifier}.json`;
};

// Called with PUT request
// Also takes two parameters in data fromSpotIdentifier and toSpotIdentifier
export const tradeSpotURL = (uidAttendee, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/trades.json`;
};

export const searchURL = (query, uidEvent = UIDEVENT, uidEventPart = UIDEVENTPART) => {
  return `${API_BASE_URL}/accommodations/events/${uidEvent}/segments/${uidEventPart}/search.json`;
};


// WEBPACK FOOTER //
// ./src/utils/restUrls.js